import { useMemo } from 'react';
import { ProviderCompletedRegistrationStepsEnum } from '../../api';
import { registrationStepLinks } from '../constants/registrations-steps';

export interface UserProgress {
  progress: number;
  lastStep: string | null;
  isProfileComplete: boolean;
}

export const useUserProgress = (
  steps: ProviderCompletedRegistrationStepsEnum[] | undefined
): UserProgress => {
  return useMemo(() => {
    if (!steps) {
      return { progress: 0, lastStep: null, isProfileComplete: false };
    }

    const totalSteps = Object.values(ProviderCompletedRegistrationStepsEnum).length;
    const progress = Math.round((steps.length / totalSteps) * 100);
    const missingSteps = Object.values(ProviderCompletedRegistrationStepsEnum).filter(
      (step) => !steps.includes(step)
    );
    const lastStep = missingSteps.length ? missingSteps[0] : null;

    return {
      progress,
      lastStep: lastStep ? registrationStepLinks[lastStep] : null,
      isProfileComplete: !missingSteps.length,
    };
  }, [steps]);
};
